import * as React from 'react';
import { Layout, Layouts, Responsive, WidthProvider } from 'react-grid-layout';
import { IBackupProvider, IMenuTab, IMenuTabItem, MenuActionEnum } from '../abstraction';
import { KWidget } from './KWidget';

interface IProps {
	id: string;
	tabItems: IMenuTabItem[];
	backupProvider: IBackupProvider;
}

interface IState {
	layouts: Layouts;
	mounted: boolean;
	currentBreakpoint: string; //Breakpoint selon la largeur de l'écran
	cols: { [breakPoint: string]: number };
}

// Détection de la largeur de l'écran
const ResponsiveGridLayout = WidthProvider(Responsive);

// Pannel permettant l'affichage de vignettes
export class KWidgetsPanel extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);
		let _cols = { lg: 3, md: 2, sm: 1 }; // Nombre de colonnes par breakpoint

		this.state = {
			layouts: {},
			mounted: false,
			currentBreakpoint: "lg",
			cols: _cols,
		}
	}

	//#region React overrides
	componentDidMount = () => {
		let _layouts = this.loadLayouts(this.props.tabItems, this.props.id);
		this.setState({ mounted: true, layouts: _layouts });
	}

	UNSAFE_componentWillReceiveProps = (nextProps: IProps) => {
		if (nextProps.id != this.props.id) {
			let _layouts = this.loadLayouts(nextProps.tabItems, nextProps.id);
			this.setState({ mounted: true, layouts: _layouts });
		}
	}

	//#endregion 

	//#region Méthodes propres au composant react-grid-layout

	loadLayouts = (tabs: IMenuTabItem[], id: string): Layouts => {
		if (tabs.filter(x => x.action == MenuActionEnum.widget)[0] == undefined) return null;

		// Chargement de la sauvegarde
		let _layouts:Layouts = JSON.parse(this.props.backupProvider.load(id));
		if (_layouts == null) { // Il n'y a pas de sauvegarde
			_layouts = this.initLayouts(
				tabs.filter(x => x.action == MenuActionEnum.widget)
					.map(
						(item, index) => this.layoutUnit(item, index)
					)
			);
		}
		return _layouts;
	}

	// Chaque widget est contenu dans un GridItem
	// Une Layout contient les GridItem, et est définie pour chaque breakpoint
	// La Layouts finale contient toutes les layout.

	// Cette méthode n'est appelée qu'en absence de sauvegarde
	// par la méthode initLayouts
	layoutUnit = (item: IMenuTabItem, index: number): Layout => {
		let unitToReturn = { i: item.id, x: 0, y: 0, w: 1, h: 5 };
		let cols = this.state.cols[this.state.currentBreakpoint];
		unitToReturn.x = index % cols;
		unitToReturn.y = Math.floor((index + 1) / cols);
		return (unitToReturn)
	}

	// Cette méthode n'est appelée qu'en absence de sauvegarde
	initLayouts = (layout: Layout[]): Layouts => {
		return ({ lg: layout, md: layout, sm: layout })
	}

	// Ici on détecte le changement de largeur de l'écran
	// donc de breakpoint, et le besoin éventuel de changer de layout
	onBreakpointChange = (breakpoint: string) => {
		this.setState({
			currentBreakpoint: breakpoint
		});
	};

	// Ici on sauvegarde la layouts après chaque modification
	// (déplacement, resize) d'un des GridItem, pour le brekpoint en cours
	// On en tient compte seulement quand le composant est chargé
	onLayoutChange = (layout: Layout[], layouts: Layouts) => {
		if (this.state.mounted == true) {
			this.props.backupProvider.save(this.props.id,JSON.stringify( layouts));
			this.setState({ layouts: layouts });
		}
	}

	//#endregion

	//#region Render()

	renderCard = (item: IMenuTabItem, index: number) => {
		return (<div key={item.id}><KWidget item={item} /></div>);
	}

	// Rendu principal
	render() {
		let tabItems = this.props.tabItems;
		if (tabItems.length == 0) return "";

		let wid = tabItems.filter(x => x.action == MenuActionEnum.widget).map((item, index) => this.renderCard(item, index));
		return (
			<div className="KWidgetView">
				<ResponsiveGridLayout
					className={"layout"}
					layouts={this.state.layouts}
					onLayoutChange={(layout, layouts) => this.onLayoutChange(layout, layouts)}
					breakpoints={{ lg: 800, md: 650, sm: 500 }}
					autoSize={true}
					cols={this.state.cols}
					compactType={"vertical"}
					onBreakpointChange={this.onBreakpointChange}
					isBounded={true}
					rowHeight={30}
				>
					{wid}
				</ResponsiveGridLayout>
			</div>
		);
	}

	//#endregion Render()
}

